import React, { useState, useEffect } from "react";
import classes from "./Reviews.module.css";
import { Container, Row, Col } from "react-bootstrap";
import { isMobileViewHook } from "../../../CustomHooks/isMobileViewHook";
import ReviewsMobile from "./ReviewMobile";
import { ReviewSidebar } from "../../../stories/ReviewSidebar/ReviewSidebar";
import Fonts from "../../../stories/assets/Fonts";
import { ReviewBox } from "../../../stories/ReviewBox/ReviewBox";
import { InputWithSearchIcon } from "../../../stories/InputWithSearchIcon/InputWithSearchIcon";
import { DropDown } from "../../../stories/DropDown/DropDown";
import Colors from "../../../stories/assets/Colors";
import {
  coachDemoImg,
  ChatFilled,
  ChatOutlined,
  HomeFilled,
  Homeoutlined,
  InsightsFilled,
  InsightsOutlined,
  NotificationFilled,
  Notificationoutlined,
  ReviewFilled,
  ReviewOutlined,
  ScheduleFilled,
  ScheduleOutlined,
  ShortLogo,
  search_svg,
  ReviewsWithHeartIcon,
} from "../../../constant/imagePath";
import { SideBarMenu } from "../../../stories/SideBarMenu/SideBarMenu";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router";
import { ReviewModal } from "../../../components/Modals/CoachFlow/Reviews/ReviewModal";
import moment from "moment";
import { ReactSVG } from "react-svg";

function NoResults() {
  return (
    <div className={classes.noResults}>
      <div>
        <ReactSVG src={search_svg} />
        <h2 style={{ ...Fonts.h4f26, color: Colors.neutralShadesOfNero }}>
          No results
        </h2>
        <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}>
          It seems we can’t find any results based on your search.
        </p>
      </div>
    </div>
  );
}
function NoReviewsYet() {
  return (
    <div className={classes.noReviewsYet}>
      <div>
        <ReactSVG src={ReviewsWithHeartIcon} />
        <h2 style={{ ...Fonts.h4f26, color: Colors.neutralShadesOfNero }}>
          You have no reviews yet
        </h2>
        <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfDimGray }}>
          As soon as the student decides to leave you a review, it will appear
          here.{" "}
        </p>
      </div>
    </div>
  );
}

const ReviewsDesktop = () => {
  const history = useHistory();
  const location = useLocation();

  const [search, setSearch] = useState("");
  const [rating, setRating] = useState({
    label: "All Rates",
    value: "all-rates",
  });
  const [show, setShow] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const sidebarMenus = [
    {
      icon: Homeoutlined,
      hoverIcon: HomeFilled,
      text: "Todo",
      onClick: () => history.push("/todo"),
      activeText: "todo",
    },
    {
      icon: Notificationoutlined,
      hoverIcon: NotificationFilled,
      text: "Notifications",
      onClick: () => history.push("/notifications"),
      activeText: "notifications",
    },
    {
      icon: ScheduleOutlined,
      hoverIcon: ScheduleFilled,
      text: "Schedule",
      onClick: () => history.push("/schedule"),
      activeText: "schedule",
    },
    {
      icon: ChatOutlined,
      hoverIcon: ChatFilled,
      text: "Chat",
      onClick: () => history.push("/chat"),
      activeText: "chat",
    },
    {
      icon: ReviewOutlined,
      hoverIcon: ReviewFilled,
      text: "Reviews",
      onClick: () => history.push("/reviews"),
      activeText: "reviews",
    },
    {
      icon: InsightsOutlined,
      hoverIcon: InsightsFilled,
      text: "Insights",
      onClick: () => history.push("/insights"),
      activeText: "insights",
    },
  ];
  const [menuItem, setMenuItem] = useState("Reviews");
  const profileReview = {
    data: {
      studentsSayings: [
        "Friendly to kids",
        "Competitive",
        "Discipline",
        "Caring",
      ],
    },
    review: {
      totalRating: 12,
      rating: 2,
      reviewsTypes: [
        {
          title: "Accuracy",
          progress: "60%",
          rating: "4.0",
        },
        {
          title: "Location",
          progress: "100%",
          rating: "5.0",
        },
        {
          title: "Value",
          progress: "40%",
          rating: "3.0",
        },
        {
          title: "Communication",
          progress: "100%",
          rating: "5.0",
        },
      ],
    },
  };

  const staticData = [
    {
      user: {
        photo: coachDemoImg,
        displayName: "Michael Baumgardner",
      },
      // Review Details
      text: "This is my first review",
      createdAt: moment("Feb 10,2022").format("MMM DD,YYYY"),
      rating: 4,
      tags: ["Friendly", "Focused"],
      type: "view-lesson",
    },
    {
      user: {
        photo: coachDemoImg,
        displayName: "Michael Baumgardner",
      },
      // Review Details
      text: "John has a knack. He can teach through his writings. He inspires confidence in his students, and by reading. Watch the Ball, you'll be inspired too.",
      createdAt: moment("June 12,2022").format("MMM DD,YYYY"),
      rating: 5,
      tags: ["Friendly", "Focused"],
      type: "view-lesson",
    },
    {
      user: {
        photo: coachDemoImg,
        displayName: "Michael Baumgardner",
      },
      // Review Details
      text: "John has a knack. He can teach through his writings. He inspires confidence in his students, and by reading. Watch the Ball, you'll be inspired too.",
      createdAt: moment("June 15,2022").format("MMM DD,YYYY"),
      rating: 3,
      tags: ["Friendly", "Focused"],
      type: "view-lesson",
    },
    {
      user: {
        photo: coachDemoImg,
        displayName: "Michael Baumgardner",
      },
      // Review Details
      text: "John has a knack. He can teach through his writings. He inspires confidence in his students, and by reading. Watch the Ball, you'll be inspired too.",
      createdAt: moment("March 10,2022").format("MMM DD,YYYY"),
      rating: 2,
      tags: ["Friendly", "Focused"],
      type: "view-lesson",
    },
    {
      user: {
        photo: coachDemoImg,
        displayName: "Michael Baumgardner",
      },
      // Review Details
      text: "John has a knack. He can teach through his writings. He inspires confidence in his students, and by reading. Watch the Ball, you'll be inspired too.",
      createdAt: moment("May 6,2022").format("MMM DD,YYYY"),
      rating: 1,
      tags: ["Friendly", "Focused"],
      type: "view-lesson",
    },
    {
      user: {
        photo: coachDemoImg,
        displayName: "Michael Baumgardner",
      },
      // Review Details
      text: "John has a knack. He can teach through his writings. He inspires confidence in his students, and by reading. Watch the Ball, you'll be inspired too.",
      createdAt: moment("Jul 10,2022").format("MMM DD,YYYY"),
      rating: 5,
      tags: ["Friendly", "Focused"],
      type: "view-lesson",
    },
  ];

  const [reviewdata, setReviewdata] = useState([...staticData]);

  useEffect(() => {
    console.log("run");
    let newData = [...staticData];
    if (show?.value == "newest-first") {
      let filterData = [];
      filterData = newData?.filter(
        (item) => moment(item?.createdAt).diff(moment().format(), "months") == 0
      );
      newData = filterData;
      setReviewdata(filterData);
    }
    if (show?.value == "oldest-first") {
      let filterData = [];
      filterData = newData?.filter(
        (item) =>
          moment(item?.createdAt).diff(moment().format(), "months") !== 0
      );
      newData = filterData;
      setReviewdata(filterData);
    }

    setReviewdata(
      rating?.value == "all-rates"
        ? newData
        : newData?.filter(
          (item) =>
            item?.rating?.toFixed(0) == parseInt(rating?.value).toFixed(0)
        )
    );
  }, [rating, show]);
  return (
    <div className={[classes.ReviewScreen].join(" ")}>
      <SideBarMenu
        logo={ShortLogo}
        items={sidebarMenus}
        state={location?.pathname.split("/")[1]}
        customStyle={{ minHeight: "100vh", height: "auto" }}
      />
      <Container fluid className={[classes.container].join(" ")}>
        <Row className={["g-0", classes.row].join(" ")}>
          <Col md={4} xl={3}>
            <ReviewSidebar data={profileReview} />
          </Col>
          <Col
            md={8}
            xl={9}
            className={[classes.p24, classes.mainContent].join(" ")}
          >
            <h3
              className={[classes.mb32].join(" ")}
              style={{ ...Fonts.h3, color: Colors.neutralShadesOfNero }}
            >
              Reviews
            </h3>
            <Row className={[classes.mb24, 'gx-2'].join(" ")}>
              <Col md={6} lg={8}>
                <InputWithSearchIcon
                  state={search}
                  setter={setSearch}
                  placeholder="Search"
                  // showSearchResults
                  searchArray={staticData}
                  renderSearchTitle={(item) => item?.user?.displayName}
                />
              </Col>
              <Col md={3} lg={2}>
                <DropDown
                  options={[
                    { label: "Newest first", value: "newest-first" },
                    { label: "Oldest first", value: "oldest-first" },
                    // { label: "Highest rated", value: "highest-rated" },
                    // { label: "Lowest rated", value: "lowest-rated" },
                  ]}
                  state={show}
                  setter={setShow}
                  placeholder="show"
                />
              </Col>
              <Col md={3} lg={2}>
                <DropDown
                  options={[
                    { label: "All Rates", value: "all-rates" },
                    { label: "1 star", value: "1" },
                    { label: "2 stars", value: "2" },
                    { label: "3 stars", value: "3" },
                    { label: "4 stars", value: "4" },
                    { label: "5 stars", value: "5" },
                  ]}
                  state={rating}
                  setter={setRating}
                  placeholder="rating"
                />
              </Col>
            </Row>
            <>
              {search == "" &&
                reviewdata?.map((item, i) => {
                  return (
                    <Row
                      key={i}
                      className={[
                        classes.pb32,
                        classes.mb32,
                        classes.borderBottom,
                      ].join(" ")}
                    >
                      <Col md={12}>
                        <ReviewBox
                          reviewData={item}
                          onClick2={() => setIsOpen(true)}
                          onClick1={() => history.push('/chat')}
                        />
                      </Col>
                    </Row>
                  );
                })}
              {search !== "" && <NoResults />}
              {reviewdata?.length == 0 && <NoReviewsYet />}
            </>
          </Col>
        </Row>
        <ReviewModal
          show={isOpen}
          setShow={setIsOpen}
          profileReviewData={profileReview}
        />
      </Container>
    </div>
  );
};

const Reviews = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  return isMobile ? <ReviewsMobile /> : <ReviewsDesktop />;
};
export default Reviews;
